import { toRelativeUrl } from "@okta/okta-auth-js";
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import React, { useEffect } from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  withRouter,
} from "react-router-dom/cjs/react-router-dom";
import App from "../App";
import { oktaAuth } from "../utils/okta-config";
import {
  ROUTE_APP_HOME,
  ROUTE_DATA_MANAGEMENT,
  ROUTE_EXTENSION,
  ROUTE_IB,
  ROUTE_BN,
  ROUTE_OKTA_CALLBACK,
  ROUTE_REPORT,
  ROUTE_DASHBOARD_BP,
  ROUTE_DASHBOARD_ADMIN,
  ROUTE_DASHBOARD_CCM
} from "../constants/constant";

const SecurityRouter = () => {
  const history = useHistory();

  useEffect(() => {
    oktaAuth.tokenManager.on("error!!!!!!!!", (err) => {
      window.open(`${window.location.origin}/`, "_self");
    });

    return () => {
      oktaAuth.tokenManager.off("error");
    };
  }, []);

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Switch>
        <Route path={ROUTE_OKTA_CALLBACK} component={LoginCallback} />
        <Route
          exact
          path={ROUTE_APP_HOME}
          render={() => <Redirect to={ROUTE_EXTENSION} />}
        />
        <SecureRoute path={ROUTE_DASHBOARD_BP} component={App} />
        <SecureRoute path={ROUTE_DASHBOARD_ADMIN} component={App} />
        <SecureRoute path={ROUTE_DASHBOARD_CCM} component={App} />
        <SecureRoute path={ROUTE_EXTENSION} component={App} />
        <SecureRoute path={ROUTE_IB} component={App} />
        <SecureRoute path={ROUTE_DATA_MANAGEMENT} component={App} />
        <SecureRoute path={ROUTE_REPORT} component={App} />
        <SecureRoute path={ROUTE_BN} component={App} />
      </Switch>
    </Security>
  );
};

export default withRouter(SecurityRouter);
